/**
 *
 * Simple Local Storage
 *  for large data
 *
 */

import isNull from 'lodash/isNull';
import { get as getCookie } from '@ts/utils/cs';

export const LS_STATE = '_ts__state';
export const LS_TOKEN_CART = '_ts__state-token-cart';
export const LS_WISH_LIST = '_ts__state-wish-list';
export const LS_CONTACT_INFO = '_ts__contact-info';
export const LS_CART_ITEM_PRODUCT_IDS = '_ts__cart-item-product-ids';
export const LS_COGNITO_USER = '_ts__cognito-user';
export const LS_COGNITO_GLOBAL_LOADING = '_ts__cognito-global-loading';
export const LS_COGNITO_SIGN_OUT = '_ts__cognito-sign-out';
export const LS_COGNITO_REDIRECT = '_ts__cognito-redirect';
export const LS_COGNITO_SIGN_UP = '_ts__cognito-sign-up';

const LocalStorage = {
    get: (name, returnDefault = null) => {
        if (typeof name !== 'string' || name.length <= 0) {
            throw new Error('Invalid key.');
        }
        const value = window.localStorage.getItem(name);
        if (value && typeof value === 'string' && value !== '[]') {
            const parsed = JSON.parse(value);
            if (parsed) {
                return parsed;
            }
        } else if (name === '_ts__contact-info' && getCookie('iterableEndUserId')) {
            set('_ts__contact-info', { user_info: { email: getCookie('iterableEndUserId') } });
            const user_info = { user_info: { email: getCookie('iterableEndUserId') } };
            return user_info;
        }

        return returnDefault;
    },
    set: (name, data = null) => {
        if (typeof name !== 'string' || name.length <= 0) {
            throw new Error('Invalid key.');
        }
        if (isNull(data)) {
            return false;
        }
        window.localStorage.setItem(name, JSON.stringify(data));
        return true;
    },
    remove: (name) => window.localStorage.removeItem(name),
    clear: () => window.localStorage.clear(),
};

const getStorage = () => {
    if (window.localStorage !== undefined) {
        return LocalStorage;
    }

    throw new Error('Storage not defined');
};

export const get = (...args) => getStorage().get(...args);
export const set = (...args) => getStorage().set(...args);
export const remove = (...args) => getStorage().remove(...args);
export const clear = (...args) => getStorage().clear(...args);

export const loadState = () => {
    try {
        const storage = getStorage();
        const state = storage.get(LS_STATE, undefined);
        return state;
    } catch (err) {
        try {
            if (err.code !== DOMException.QUOTA_EXCEEDED_ERR) {
                console.log(err); // eslint-disable-line no-console
            }
        } catch (ign) {
            // ignore
        }
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const storage = getStorage();
        return storage.set(LS_STATE, state);
    } catch (err) {
        try {
            if (err.code !== DOMException.QUOTA_EXCEEDED_ERR) {
                console.log(err); // eslint-disable-line no-console
            }
        } catch (ign) {
            // ignore
        }
        return false;
    }
};
